import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var PlatformType;

(function (PlatformType) {
  PlatformType["WEB"] = "WEB";
  PlatformType["APP"] = "APP";
})(PlatformType || (PlatformType = {}));

var PlatformUtil = function PlatformUtil() {
  _classCallCheck(this, PlatformUtil);

  _defineProperty(this, "PLATFORM_TYPE", void 0);
};

export { PlatformUtil as default };